<div class="main">
  <div *ngIf="showLoader" class="loader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div class="header">
    <h3>{{'RESTRICTEDLOCATION.restrictedLocation' | translate}}</h3>
  </div>

  <div class="section">
    <div class="map-container" id="pathMap"></div>
    <div class="major-list-container">
      <div class="header-container">
        <header
          class="master-restricted-list {{selectedRestrictedList === 'master' ? 'selected' : ''}}"
          (click)="changeRestrictedList('master')">
          {{'RESTRICTEDLOCATION.masterRestrictedLocation' | translate}}
        </header>
        <header
          class="my-restricted-list {{selectedRestrictedList === 'my' ? 'selected' : ''}}"
          (click)="changeRestrictedList('my')">
          {{'RESTRICTEDLOCATION.myRestrictedLocation' | translate}}
        </header>
      </div>
      <div class="filter-container">
        <div class="search-container">
          <div class="search-input-container">
            <input
              type="text"
              class="search-input"
              [placeholder]="'RESTRICTEDLOCATION.searchEntityArea' | translate"
              [(ngModel)]="searchTerm" />
          </div>
          <div class="search-icon-container">
            <button
              class="search-button"
              (click)="onSearch()"
              aria-label="Search">
              <img
                src="../../assets/search_icon.svg"
                alt="Search"
                class="search-icon" />
            </button>
          </div>
        </div>
        <div class="filterbyState-addlocation">
          <div class="filterBystate">
            <select
              [(ngModel)]="selectedStateCode"
              (change)="onStateChange($event)">
              <option value="">Select a State</option>
              <option *ngFor="let state of states" [value]="state.code">
                {{ state.name }}
              </option>
            </select>
          </div>
          <div class="addlocation">
            <button class="add-location-button" (click)="onAddLocation()">
              <span class="plus-icon">+</span>
              Add Location
            </button>
          </div>
        </div>
      </div>
      <div class="list-container">
        <table class="location-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>State</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let location of locations">
              <td>{{ location.name }}</td>
              <td>{{ location.area }}</td>
              <td>{{ location.state }}</td>
              <td>{{ location.desc }}</td>
              <td>
                <button class="action-button" (click)="onGeofence(location)">
                  Geofence
                </button>
                <button
                  class="action-button"
                  (click)="onDeleteLocation(location)">
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="pagination" class="pagination">
        <div class="items-per-page">
          Items per page:
          <select (change)="onItemsPerPageChange($event)">
            <option *ngFor="let option of itemsPerPageOptions" [value]="option">
              {{ option }}
            </option>
          </select>
        </div>

        <div class="item-count">
          showing {{ (currentPage - 1) * itemsPerPage + 1 }} - {{
          Math.min(currentPage * itemsPerPage, totalCount) }} of {{ totalCount
          }} Locations
        </div>

        <div class="pagination-buttons">
          <button
            class="pagination-button"
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1">
            Previous
          </button>
          <button
            style="margin-left: 10px"
            class="pagination-button"
            (click)="goToNextPage()">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addRestrictedLocation>
  <div class="add-location-popup">
    <div class="popup-header">
      <h3>Add Restricted Location</h3>
      <button class="close-button" (click)="closeAddRestrictedLocationDialog()">
        ×
      </button>
    </div>

    <div class="mapview-popup-container">
      <div class="popup-body">
        <div class="form-group">
          <label for="area">Area</label>
          <input
            type="text"
            id="area"
            [(ngModel)]="newLocation.area"
            (input)="onInputChange($event.target.value)"
            class="form-control"
            placeholder="Type to search for area"
            (blur)="onInputBlur()"
            autocomplete="off" />

          <select
            style="margin-top: 15px"
            id="area-dropdown"
            class="form-control"
            *ngIf="areaSuggestions.length > 0"
            (change)="selectAreaFromDropdown($event.target.value)">
            <option value="" disabled selected>Select Area</option>
            <option
              *ngFor="let suggestion of areaSuggestions"
              [value]="suggestion.description"
              (click)="areaSuggestions = []">
              {{ suggestion.description }}
            </option>
          </select>
        </div>

        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 20px;
          ">
          <div class="form-group" style="width: 100%">
            <label for="name">Name</label>
            <input type="text" id="name" [(ngModel)]="newLocation.name" />
          </div>
          <div class="form-group" style="width: 100%">
            <label for="landmark">Landmark</label>
            <input
              type="text"
              id="landmark"
              [(ngModel)]="newLocation.landmark" />
          </div>
        </div>

        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 20px;
          ">
          <div class="form-group" style="width: 100%">
            <label for="pincode">Pincode</label>
            <input type="text" id="pincode" [(ngModel)]="newLocation.pincode" />
          </div>

          <div class="form-group" style="width: 100%">
            <label for="city">City</label>
            <input type="text" id="city" [(ngModel)]="newLocation.city" />
          </div>

          <div class="form-group" style="width: 100%">
            <label for="state">State</label>
            <input type="text" id="state" [(ngModel)]="newLocation.state" />
          </div>
        </div>

        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 20px;
          ">
          <div class="form-group" style="width: 100%">
            <label for="severity">Severity</label>
            <select id="severity" [(ngModel)]="newLocation.severity">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>
          <div class="form-group" style="width: 100%">
            <label for="type">Type</label>
            <select [(ngModel)]="selectedType" (change)="onTypeChange($event)">
              <option value="">Select a Type</option>
              <option *ngFor="let type of typeForNewLocation" [value]="type">
                {{ type }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label for="description">Description</label>
          <textarea
            id="description"
            [(ngModel)]="newLocation.description"></textarea>
        </div>
      </div>

      <div class="mapview-popup" id="addLocationMap"></div>
    </div>

    <div class="location-details" *ngIf="selectedLocation">
      <div>
        Latitude:
        <span style="font-weight: 700">{{ selectedLocation.lat }}</span>
      </div>
      <div>
        Longitude:
        <span style="font-weight: 700">{{ selectedLocation.lng }}</span>
      </div>
    </div>

    <div class="popup-footer">
      <button class="save-button" (click)="onSaveLocation()">Save</button>
    </div>
  </div>
</ng-template>

<ng-template #geofencepopup>
  <div class="geofence-popup">
    <div class="popup-header-geofence">
      <h3>Geofence</h3>
      <button class="close-button" (click)="closeGeofencePopup()">×</button>
    </div>
    <div class="popup-body-geofence">
      <div class="mapcontaioner-geofence" id="geofenceMap"></div>
      <div class="location-details-geofence">
        <div class="locationdetails-geofence">
          <div style="margin-top: 12px">
            <div style="color: #6a7280">Name</div>
            <div style="font-size: 16px; color: #111827; font-weight: 700">
              {{ selectedLocationGeofence?.name }}
            </div>
          </div>
          <div>
            <div style="color: #6a7280">Area</div>
            <div style="font-size: 16px; color: #111827; font-weight: 700">
              {{ selectedLocationGeofence?.area }}
            </div>
          </div>
          <div>
            <div style="color: #6a7280">Type</div>
            <div style="font-size: 16px; color: #111827; font-weight: 700">
              {{ selectedLocationGeofence?.type }}
            </div>
          </div>
          <div>
            <div style="color: #6a7280">Severity</div>
            <div style="font-size: 16px; color: #111827; font-weight: 700">
              {{ selectedLocationGeofence?.severity }}
            </div>
          </div>

          <div>
            <div style="color: #6a7280">Geofences</div>
            <div
              style="
                display: flex;
                flex-direction: column;
                gap: 6px;
                margin-top: 4px;
                margin-bottom: 9px;
              ">
              <div
                *ngFor="let geofence of selectedLocationGeofence?.geofences; let i = index"
                (mouseenter)="highlightGeofence(geofence.id)"
                (mouseleave)="unhighlightGeofence(geofence.id)"
                style="
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  background-color: #f3f4f6;
                  padding: 6px;
                  border-radius: 7px;
                "
                [ngClass]="{'highlighted': highlightedGeofence === geofence.id}">
                <div>Geofence No. {{ i + 1 }}</div>
                <button
                  style="
                    cursor: pointer;
                    padding: 0;
                    border: none;
                    background-color: transparent;
                    height: 20px;
                    width: 20px;
                  "
                  (click)="deleteGeofence(geofence.id)">
                  <img
                    src="../../assets/delete.svg"
                    alt="delete icon"
                    style="width: 100%; height: 100%; object-fit: contain" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="savebutton-geofence">
          <button
            class="button-geofence-save"
            (click)="saveGeofence()"
            *ngIf="isNewGeofence">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteConfirmationDialog>
  <div class="delete-confirmation-dialog">
    <h2>Confirm Deletion</h2>
    <p>Are you sure you want to delete this location?</p>
    <div class="dialog-buttons">
      <button class="cancel-button" (click)="closeDeleteConfirmationDialog()">
        Cancel
      </button>
      <button class="delete-button" (click)="confirmDeleteLocation()">
        Delete
      </button>
    </div>
  </div>
</ng-template>